import { Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { BaseModal } from 'src/shared/components/Modals/BaseModal';

type DeleteCollectiveModalProps = {
  closeModal: () => void;
  onConfirm: () => void;
  title: string;
  btnText: string;
  description: string;
};

export const PromptConfirmationModal = ({
  closeModal,
  onConfirm,
  title,
  btnText,
  description
}: DeleteCollectiveModalProps) => {
  const handleConfirm = () => {
    onConfirm();
    closeModal();
  };

  return (
    <BaseModal title={title} btnText={btnText} handleCancel={closeModal} handleConfirm={handleConfirm}>
      <Typography
        variant="body1"
        sx={{ maxWidth: '500px', textAlign: 'left' }}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
      />
    </BaseModal>
  );
};
